/* global powerbi */
import React, { useEffect } from "react";
import * as pbi from "powerbi-client";
import { getPowerBiEmbedToken } from "../helpers/apiRequests";

let report; // holds reference to embedded report
let reportUpdateInterval; // for storing setInterval ref so can clear on unmount

const reportConfiguration = (embedToken, reportId, pageId) => ({
  type: "report",
  id: reportId,
  embedUrl: "https://app.powerbi.com/reportEmbed",
  tokenType: pbi.models.TokenType.Embed,
  accessToken: embedToken,
  pageName: pageId,
  // pageName: "ReportSection8e4383a9acaf3150899d",
  viewMode: pbi.models.ViewMode.View,
  permissions: pbi.models.Permissions.Read,
  settings: {
    filterPaneEnabled: false,
    navContentPaneEnabled: false,
    background: pbi.models.BackgroundType.Transparent
  }
});

const updateReportEmbedToken = (tokenStore, reportId) =>
  getPowerBiEmbedToken(tokenStore.getToken(), reportId).then(embedToken =>
    report.setAccessToken(embedToken)
  );

const scheduleEmbedTokenRefresh = (tokenStore, reportId) => {
  reportUpdateInterval = setInterval(
    () => updateReportEmbedToken(tokenStore, reportId),
    1000 * 60 * 4 // update token every 4 minutes
  );
};

const embedReport = (tokenStore, reportId, pageId) =>
  getPowerBiEmbedToken(tokenStore.getToken(), reportId).then(embedToken => {
    const reportElement = document.getElementById("report");
    report = powerbi.embed(
      reportElement,
      reportConfiguration(embedToken, reportId, pageId)
    );
    scheduleEmbedTokenRefresh(tokenStore, reportId);
  });

const ReportEmbedContainer = () => (
  <div
    className="report-container"
    style={{
      width: "100%",
      height: "642px",
      overflow: "visible",
      paddingTop: "0"
    }}
  >
    <div id="report" className="powerbiReport" />
  </div>
);

const ReportWrapper = props => (
  <div>
    <div className="report-failureMessage">Failed to load data</div>
    <ReportLoader {...props} />
    <ReportEmbedContainer />
  </div>
);

const ReportLoader = ({ tokenStore, reportId, pageId }) => {
  useEffect(() => {
    embedReport(tokenStore, reportId, pageId);
    return () => clearInterval(reportUpdateInterval);
  }, []);

  return <div></div>;
};

export default ReportWrapper;
